import { Box, Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import { useMenuTriggerTooltip } from './use-menu-trigger-tooltip';

type Props = Pick<TooltipProps, 'title' | 'placement' | 'arrow'> & {
    /** The trigger. Call `onMenuOpenChange` whenever its menu (or a dialog it owns) opens or closes. */
    children: (onMenuOpenChange: (open: boolean) => void) => React.ReactNode;
    sx?: React.ComponentProps<typeof Box>['sx'];
};

/**
 * MUI tooltip for a button that opens a menu: shut while the menu (or a dialog it
 * launched) is open, and not brought back by focus returning to the trigger.
 * See useMenuTriggerTooltip for why.
 */
export default function MenuTriggerTooltip({ title, placement = 'bottom', arrow = true, children, sx }: Props) {
    const tip = useMenuTriggerTooltip();
    return (
        <Tooltip
            title={title}
            placement={placement}
            arrow={arrow}
            open={tip.tooltipOpen}
            onOpen={tip.onTooltipOpen}
            onClose={tip.onTooltipClose}
            disableFocusListener
        >
            <Box component="span" sx={{ display: 'inline-flex', ...sx }} onPointerEnter={tip.onTriggerPointerEnter} onPointerDownCapture={tip.onTooltipClose}>
                {children(tip.onMenuOpenChange)}
            </Box>
        </Tooltip>
    );
}
